import {
  FETCH_PROFILE_REQUEST,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  profile: null,
  error: null,
  success: false,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_PROFILE_SUCCESS:
      return { ...state, loading: false, profile: action.payload, error: null, success: true };

    case FETCH_PROFILE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    default:
      return state;
  }
};

export default profileReducer;
